import React from "react";
import DailyTransactions from "./DailyTransactions";

const DigitalPaymentTxn = () => {
  return (
    <div>
      <DailyTransactions />
    </div>
  );
};

export default DigitalPaymentTxn;
